import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
// 这里定义初始值
let state = {
  id:0,
  activeNames:'',
  seekResult:[],
  projectName:{},
};

const mutations = {
  getId(state,id){
    console.log('id','============')
    state.id = id;
  },
  getName(state,name){
    state.activeNames = name;
  },
  getSeekResult(state,data){
    state.seekResult = data;
  },
  project(state,name1){
    state.projectName = name1
  }
};
// 事件触发后的逻辑操作
// 参数为事件函数
const actions = {

};

// 返回改变后的数值
const getters = {  //过滤

};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js